// extracted by mini-css-extract-plugin
export default {"loadingIndicator":"_2P6582u5nZJz_siGc0tLVz"};